import { FC } from 'react';
import EditorImg from 'lowcode/components/EditorImg';
import EfSpec from '@elem/ui/ef-spec';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

const E: FC = () => {
    const { t } = useLang('ces2025');

    const data = [
        {
            tit: t('E_card1_t'),
            desc: t('E_card1_d'),
        },
        {
            tit: t('E_card2_t'),
            desc: t('E_card2_d'),
        },
        {
            tit: t('E_card3_t'),
            desc: t('E_card3_d'),
        },
        {
            tit: t('E_card4_t'),
            desc: t('E_card4_d'),
        },
        {
            tit: t('E_card5_t'),
            desc: t('E_card5_d'),
        },
    ];

    return (
        <section className={styles.Card} id="CES-2025-E">
            <EfSpec />
            <EditorImg
                pc="https://websiteoss.ecoflow.com/upload/image/1733214876853/ces-d-pc.jpg"
                pad="https://websiteoss.ecoflow.com/upload/image/1733391790226/PowerSolution_h5.jpg"
                h5="https://websiteoss.ecoflow.com/upload/image/1733391790226/PowerSolution_h5.jpg"
                className="banner"
            ></EditorImg>
            <div className="text-box">
                <div className="title pc">
                    {t.rich('E_title', {
                        slot: () => (
                            <div className="title_icon">
                                <EditorImg pc="https://websiteoss.ecoflow.com/upload/image/1733998183174/ces-d-icon1.png"></EditorImg>
                            </div>
                        ),
                    })}
                </div>
                <div className="title h5">
                    {t.rich('E_title1', {
                        wrap: (text: string) => <div className="h5_first_row">{text}</div>,
                        slot: () => (
                            <div className="title_icon">
                                <EditorImg pc="https://websiteoss.ecoflow.com/upload/image/1733998183174/ces-d-icon1.png"></EditorImg>
                            </div>
                        ),
                    })}
                </div>
                <div className="desc">{t('E_desc')}</div>
                <div className="box">
                    {data.map((item, i) => (
                        <div className="box_item" key={i}>
                            <div className="box_item_title">{item.tit}</div>
                            <div className="box_item_desc">{item.desc}</div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default E;
